import React, { Component } from "react";
import AdminHeader from "../components/AdminHeader";
import AdminFooter from "../components/AdminFooter";
import Dashboard from "../components/Dashboard";
import ImageModal from "../components/ImageModal";
import * as actions from "../actions";
import { connect } from "react-redux";
// import { Link } from 'react-router-dom';

class ModerationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_image_url: "",
      active_filter_button: "all"
    };
    
    this.setActiveImage    = this.setActiveImage.bind(this);
    this.setActiveFilter   = this.setActiveFilter.bind(this);
    this.filterEntries     = this.filterEntries.bind(this);
    this.approvedEntries   = this.approvedEntries.bind(this);
    this.rejectEntry       = this.rejectEntry.bind(this);
    this.currentLocation   = this.props.location.pathname.replace(/\//g,'');
  }

  setActiveImage(image_url) {
    this.setState({ active_image_url: image_url });
  }
  setActiveFilter(filterBtn) {
    this.setState({ active_filter_button: filterBtn });
  }
  
  filterEntries(filterOption){
    this.props.fetchImages(filterOption);
  }
  approvedEntries() {
    this.props.approvedAllEntries();
  }

  rejectEntry(entryID) {
    this.props.rejectSingleEntry(entryID)
  }
  
  componentWillMount() {
    this.props.fetchImages(this.state.active_filter_button);
  }

  
  render() {
    return (
      <div className="row">
        {this.state.active_image_url ? (
          <ImageModal
            active_image_url={this.state.active_image_url}
            setActiveImage={this.setActiveImage}
          />
        ) : null}

        
        <AdminHeader 
            setActiveFilter={this.setActiveFilter}/>

        <Dashboard
          setActiveImage={this.setActiveImage}
          images={this.props.images}
          active_filter_button={this.state.active_filter_button}
          filterEntries={this.filterEntries}
          currentLocation={this.currentLocation}
          rejectEntry={this.rejectEntry}
        />
        <AdminFooter 
          approvedEntries={this.approvedEntries}
          filterEntries={this.filterEntries}/>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    images: state.images
  };
}
export default connect(mapStateToProps, actions)(ModerationPage);




// WEBPACK FOOTER //
// ./src/containers/ModerationPage.js